import _ from 'lodash';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../common/utils';
import CopyToClipboardButton from '../../../components/actions/CopyToClipboardButton';
import CodeEditor from '../../../components/editors/CodeEditor';
import InboxZero from '../../../components/InboxZero';
import { Container } from '../../../components/layout/ContainerFlex';
import { Spacer } from '../../../components/layout/Spacer';
import { ActionBar } from '../../../components/nav/ActionBar';

export type ImporterSQLPreviewProps = {
  data: Object[];
};

const jsonToSQL = (json: Object | undefined | null): string => {
  if (!json) {
    return '-- No data available';
  }

  const keys = Object.keys(json);
  if (keys.length === 0) {
    return '-- No columns available';
  }

  const columns = keys.map(key => `"${key}"`).join(',\n  ');
  return `
SELECT
  ${columns}
FROM
  {{#input}}
`;
};

const ImporterSqlPreview: React.FC<ImporterSQLPreviewProps> = props => {
  const { t } = useTranslation('importer');
  const [currentIndex, setCurrentIndex] = useState(0);

  const hasData = Array.isArray(props.data) && props.data.length > 0;
  const currentData = hasData ? props.data[currentIndex] : null;
  const sqlQuery = jsonToSQL(currentData);

  if (!hasData) {
    return (
      <Container col className="relative">
        <InboxZero selfCenter hasIcon message={t`No data available`} />
      </Container>
    );
  }

  return (
    <Container col className="relative">
      <div className="h-full overflow-hidden">
        <ActionBar sticky stickyTop>
          <CopyToClipboardButton
            className={cn('rounded-none')}
            hasIcon
            hasIconSmall
            value={sqlQuery}
          />
          <Spacer flexspace />
        </ActionBar>

        <CodeEditor
          value={sqlQuery}
          onChange={_.noop}
          language="trinosql"
          // placeholder="Enter your SQL query here..."
          editorOptions={{ readOnly: true }}
          // height="300px"
        />
      </div>
    </Container>
  );
};

export default ImporterSqlPreview;
